import { useState, useCallback, useEffect } from "react";
import { APIError, useAxios } from "../core/_axios";
import { Service } from "../core/_models";
import { getActiveService } from "../core/_requests";

function useActiveService() {

    const axios = useAxios();

    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState<string | null>(null);

    const [activeService, setActiveService] = useState<Service | null>(null);

    const loadActiveService = useCallback(async () => {
        // Disabing active service for now
        setLoading(false);
        return;
        setLoading(true);
        setLoadingError(null);
        try {
            const updatedService = await getActiveService(axios);
            setActiveService(updatedService);
        } catch (exception) {
            console.error(exception)
            const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
            setLoadingError(errorMessage)
        } finally {
            setLoading(false)
        }
    }, [axios]);

    useEffect(() => {
        loadActiveService();
    }, [loadActiveService]);

    return {
        loading,
        loadingError,
        activeService,
    }

}

export default useActiveService;